import React from 'react'

function HospitalDataBackup() {
  return (
    <div>"Data Backup & Restore</div>
  )
}

export default HospitalDataBackup